export default __webpack_public_path__ + "static/media/samantha.9fbb6ebd.jpeg";